import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса ведения кассиров собственной кассы (RP-OWN11). Состав кассиров — `Resource.Receipts`, право
 * `receipts.cashiers.manage` на ресурсе; PIN и отзыв доступа — `Cashiers` (`platform:cashiers:manage`). Литерал `/api/` законен
 * только здесь.
 */
const roster = (resourceId: string) => `/api/receipts/v1/resources/${ridSegment(resourceId)}/cashier-roster`

export const OWN_CASHIER_URLS = {
  /** `GET` — список с архивными; `POST` — новый кассир. */
  roster,
  /** `PUT` — переименование, архив и возврат с версией узла. */
  rosterItem: (resourceId: string, cashierId: string) => `${roster(resourceId)}/${encodeURIComponent(cashierId)}`,
  /** `GET ?resourceId=&cashierKey=&sourceCashierId=` — версия настроек доступа кассира (нужна для отзыва). */
  accessSettings: '/api/cashiers/v1/settings',
  /** `POST` — отозвать PIN и действующий доступ кассира. */
  accessRevoke: '/api/cashiers/v1/settings/revoke',
} as const
